import { el } from '../core/dom.js';

/**
 * @param {{ title: string, body: Node|string, className?: string, onClose?: () => void }} opts
 */
export function openModal(opts) {
  const scrim = el('div', { class: 'scrim' });
  const panel = el('div', {
    class: `modal${opts.className ? ` ${opts.className}` : ''}`,
    role: 'dialog',
    'aria-modal': 'true',
    'aria-label': opts.title,
  },
  el('header', { class: 'drawer-head' },
    el('h2', {}, opts.title),
    el('button', { type: 'button', class: 'icon-btn', 'aria-label': 'Close', onClick: () => close() }, '×')),
  el('div', { class: 'modal-body' }, opts.body));

  function close() {
    scrim.remove();
    panel.remove();
    document.removeEventListener('keydown', onKey);
    if (opts.onClose) opts.onClose();
  }

  function onKey(event) {
    if (event.key === 'Escape') close();
  }

  scrim.addEventListener('click', close);
  document.addEventListener('keydown', onKey);
  document.body.append(scrim, panel);
  return { close };
}
